import Home5 from "../views/GuPiao/HomeView.vue";
export default [
  {
    path: "/home5",
    component: Home5,
    redirect: "/gupiao",
    children: [
      {
        //互联网大数据
        path: "/gupiao",
        name: "gupiao",
        component: () => import("../views/GuPiao/indexView.vue"),
        meta: {
          title: "股票资讯页面",
        },
      },
    ],
  },
];
